module.exports = __webpack_public_path__ + "static/media/banner2-julho2024.a2eb5631.jpg";